import { qs, listen, toggle } from '@fluorescent/dom';

import { section } from '@/glow';

section('search', {
  onLoad() {
    const clearButton = qs('[data-clear-search]', this.container);
    const searchButton = qs('.search__submit', this.container);
    const searchInput = qs('[data-search-input]', this.container);

    toggle([clearButton, searchButton], 'visible', searchInput.value !== '');

    this.events = [
      listen(clearButton, 'click', () => {
        searchInput.value = '';
        toggle(
          [clearButton, searchButton],
          'visible',
          searchInput.value !== ''
        );
      }),
      listen(searchInput, 'input', e =>
        toggle([clearButton, searchButton], 'visible', e.target.value !== '')
      ),
    ];
  },

  onUnload() {
    this.buttonHandler();
  },
});
